import React from "react";

// inhouse icons
import { Search, X } from "@/components/icons_new";

const DiscountSearchControls = ({
  searchTerm,
  updateSearchTerm,
}) => {
  return (
    <div className="mb-[1em] px-[0.5em] py-[0.5em] flex flex-col gap-[1em] border bg-white rounded-t-xl">
      
      {/* Search input */}
      <div className="bg-[#F8F8F8] relative px-3 py-2 rounded-md flex flex-row items-center gap-[1em]">
        <Search className="w-5 h-5 text-[#737373]" />

        <input
          type="text"
          placeholder="Search discounts by name or code..."
          value={searchTerm}
          onChange={(e) => {
            const raw = e.target.value;
            const sanitized = raw
              .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
              .trim()
              .slice(0, 100);
            updateSearchTerm(sanitized);
          }}
          className="w-full text-[#000] bg-[#F8F8F8] placeholder:text-[#000] outline-none font-medium"
        />

        {searchTerm && (
          <button
            onClick={() => updateSearchTerm("")}
            className="absolute right-3 text-[#999] hover:text-black"
            aria-label="Clear search"
          >
            <X className="w-5 h-5 text-[#000000]" />
          </button>
        )}
      </div>
    </div>
  );
};

export default DiscountSearchControls;
